var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 244,
    viewBox: "0 0 162 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 50,
    transform: "translate(199.278 243.271) rotate(-147.994)",
    fill: "#EE0026"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 50,
    transform: "translate(228.429 196.631) rotate(-147.994)",
    fill: "#EE0026"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 85,
    transform: "translate(96.9897 114.48) rotate(-147.994)",
    fill: "#34629D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.878e9296405ceee2c5759920d6e2fd14.svg";
export { ForwardRef as ReactComponent };